export default __webpack_public_path__ + "static/media/arrow-undo-outline.e3d7c780.svg";